import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { ListaGeocerca } from 'src/app/models/mapa-geocerca';


@Injectable({
    providedIn: 'root'
})
export class MapToolsService {

    qs = require('qs');

    tipoMapaActual: any = { recorrido: false, verflota: true };

    tipoMapaObs = new Subject<any>();
    zoomMapaObs = new Subject<any>();
    centerMapaObs = new Subject<any>();
    displayMarkerObs = new Subject<any>();

    trafficLayer = true;
    trafficLayerObs = new Subject<any>();

    cargaGeocercas = false;
    cargaGeocercasObs = new Subject<any>();

    cargaPuntos = false;
    cargaPuntosObs = new Subject<any>();

    geocercas = <any>[];
    geocercaObs = new Subject<any>();

    puntoMap = <any>[];
    puntoMapObs = new Subject<any>();

    // Nuevas propiedades para estilos de mapa
    mapTypeId = 'roadmap'; // Valor por defecto: estándar
    mapTypeIdObs = new Subject<any>();

    // Mapa de calor
    heatmapVisible = false;
    heatmapObs = new Subject<any>();

    // Visualización de terreno
    terrainVisible = false;
    terrainObs = new Subject<any>();

    // Herramientas de medición
    medicionDistancia = false;
    medicionDistanciaObs = new Subject<any>();

    medicionArea = false;
    medicionAreaObs = new Subject<any>();

    // Selección de puntos para rutas en el mapa
    seleccionRutasActiva = false;
    seleccionRutasActivaObs = new Subject<boolean>();
    puntoRutaSeleccionadoObs = new Subject<{ lat: number, lng: number }>();

    // Puntos temporales para mostrar durante la selección
    puntosTemporalesRuta: any[] = [];
    puntosTemporalesRutaObs = new Subject<any[]>();

    // Referencia al mapa de Google Maps
    private mapaInstancia: any = null;

    constructor(
        private http: HttpClient
    ) {

    }

    /**
     * Almacenar referencia al mapa
     */
    setMapa(mapa: any) {
        this.mapaInstancia = mapa;
    }

    /**
     * Obtener referencia al mapa
     */
    getMapa() {
        return this.mapaInstancia;
    }

    /**
     * Observable Tipo de Mapa
     */
    getObsTipoMapa() { return this.tipoMapaObs.asObservable(); }

    /**
     * Set Observable Tipo de Mapa
     */
    setTipoMapa(obj) { this.tipoMapaActual = obj; this.tipoMapaObs.next(obj); }

    /**
     * Observable Centrar Mapa
     */
    getObsCenterMapa() { return this.centerMapaObs.asObservable(); }
    /**
     * Set Observable Centrar Mapa
     */
    setCenterMapa(obj) { this.centerMapaObs.next(obj); }

    /**
     * Observable Mostrar / Ocultar Markers
     */
    getObsDisplayMarker() { return this.displayMarkerObs.asObservable(); }
    /**
     * Set Observable Mostrar / Ocultar Markers
     */
    setDisplayMarker(obj) {
        this.displayMarkerObs.next(obj);
    }

    getGeocercas() {
        var filter = {
            order: "nombre",
        }
        let urlFilter = this.qs.stringify(filter);
        return this.http.get(`${environment.baseUrl}clientes/geocercas/?` + urlFilter);
    }
    callGeocercas(){
        this.getGeocercas().subscribe(res => {
            let data = [];
            //console.log(res)
            res['rows'].forEach(el => {
                //console.log(el)
                data.push(new ListaGeocerca(el));
            });
            this.setGeocercas(data);
        });
    }
    /**
     * Set Observable Mostrar / Ocultar Geocerca
     */
    setGeocercas(obj) {
        //console.log(obj)
        this.geocercas = obj;
        this.geocercaObs.next(obj);
    }
    /**
    * Observable Mostrar / Ocultar Geocerca
    */
    getGeocercasObs() { return this.geocercaObs.asObservable(); }

    getZoomMapaObs() { return this.zoomMapaObs.asObservable(); }
    setZoomMapaObs(obj) { return this.zoomMapaObs.next(obj); }

    /**
     * Muestra Tráfico en Mapa
     */
    getTrafficObs() { return this.trafficLayerObs.asObservable(); }
    setTrafficObs(obj) { return this.trafficLayerObs.next(obj); }


     /**
     * Cargar Geocerca en Mapa
     */
     getCargaGeocercaObs() { return this.cargaGeocercasObs.asObservable(); }
     setCargaGeocercaObs(obj) { return this.cargaGeocercasObs.next(obj); }

     /**
     * Cargar Puntos en Mapa
     */
     getCargaPuntosObs() { return this.cargaPuntosObs.asObservable(); }
     setCargaPuntosObs(obj) { return this.cargaPuntosObs.next(obj); }

    /**
     * Carga Puntos en Mapa
    */
    getPuntoMapObs() {
        return this.puntoMapObs.asObservable();
    }
    setPuntoMapObs(obj) {
        //console.log(obj)
        this.puntoMap = obj;
        this.puntoMapObs.next(obj);
    }

    /**
     * Tipo de mapa (roadmap, satellite, hybrid, terrain)
     */
    getMapTypeObs() { return this.mapTypeIdObs.asObservable(); }
    setMapTypeObs(type) {
        this.mapTypeId = type;
        this.mapTypeIdObs.next(type);
    }

    /**
     * Mapa de calor
     */
    getHeatmapObs() { return this.heatmapObs.asObservable(); }
    setHeatmapObs(visible) {
        this.heatmapVisible = visible;
        this.heatmapObs.next(visible);
    }

    /**
     * Visualización de terreno
     */
    getTerrainObs() { return this.terrainObs.asObservable(); }
    setTerrainObs(visible) {
        this.terrainVisible = visible;
        this.terrainObs.next(visible);
    }

    /**
     * Medición de distancia
     */
    getMedicionDistanciaObs() { return this.medicionDistanciaObs.asObservable(); }
    setMedicionDistanciaObs(active) {
        this.medicionDistancia = active;
        this.medicionDistanciaObs.next(active);
    }

    /**
     * Cálculo de áreas
     */
    getMedicionAreaObs() { return this.medicionAreaObs.asObservable(); }
    setMedicionAreaObs(active) {
        this.medicionArea = active;
        this.medicionAreaObs.next(active);
    }

    /**
     * Selección de puntos para rutas en el mapa
     */
    getSeleccionRutasActivaObs() { return this.seleccionRutasActivaObs.asObservable(); }
    setSeleccionRutasActiva(active: boolean) {
        this.seleccionRutasActiva = active;
        this.seleccionRutasActivaObs.next(active);
    }

    /**
     * Observable para puntos de ruta seleccionados en el mapa
     */
    getPuntoRutaSeleccionadoObs() { return this.puntoRutaSeleccionadoObs.asObservable(); }
    setPuntoRutaSeleccionado(punto: { lat: number, lng: number }) {
        this.puntoRutaSeleccionadoObs.next(punto);
    }

    /**
     * Puntos temporales para mostrar durante la selección de rutas
     */
    getPuntosTemporalesRutaObs() { return this.puntosTemporalesRutaObs.asObservable(); }
    setPuntosTemporalesRuta(puntos: any[]) {
        this.puntosTemporalesRuta = puntos;
        this.puntosTemporalesRutaObs.next(puntos);
    }
    clearPuntosTemporalesRuta() {
        this.puntosTemporalesRuta = [];
        this.puntosTemporalesRutaObs.next([]);
    }
}
